import { render, staticRenderFns } from "./CommentsCollapseItemRefresh.vue?vue&type=template&id=696c34bc&"
import script from "./CommentsCollapseItemRefresh.vue?vue&type=script&lang=js&"
export * from "./CommentsCollapseItemRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports